import React from "react";
import { Card } from "antd";
import styled from "styled-components";
import LanguageSelector from "Components/Shared/LanguageSelector";

const Powered = ({ customStyle }) => {
  const linkColor = customStyle?.link?.linkColor;
  const hoverLinkColor = customStyle?.link?.hoverLinkColor;

  const StyledA = styled.a`
    display: inline-block;
    cursor: pointer;
    text-decoration: none;
    color: ${linkColor};
    cursor: pointer;

    &:hover {
      color: ${hoverLinkColor};
      text-decoration: underline;
    }
  `;
  return (
    <Card size="small" className="card-powered no-radius-bottom">
      <div className="card-powered-content">
        <div className="powered-brand">
          <span className="powered-by-label">Powered by</span>{" "}
          <StyledA href={"https://salespark.io/?utm_source=checkout&utm_medium=powered_by"} target="_blank" rel="noreferrer">
            SalesPark
          </StyledA>
        </div>

        <LanguageSelector customStyle={customStyle} style={{ position: "absolute", right: 0, fontSize: "0.6rem" }} />
      </div>
    </Card>
  );
};

export default Powered;
